import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuthStore } from "@/lib/store";

export function Header() {
  const logout = useAuthStore((s) => s.logout);
  const hasToken =
    typeof window !== "undefined" && !!localStorage.getItem("access_token");
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 px-3 pt-4 md:px-4 lg:px-5">
      <div className="mx-auto max-w-[92rem] frost-panel rounded-2xl px-4 md:px-6">
        <div className="h-16 flex items-center justify-between">
          <Link to="/" className="text-xl font-black tracking-tight text-ink">
            roam<span className="text-warm">.</span>
          </Link>

          <nav className="hidden sm:flex items-center gap-1">
            <Link
              to="/"
              className={`px-3.5 py-2 text-sm rounded-lg transition-colors font-medium ${
                isActive("/")
                  ? "text-deep bg-warm"
                  : "text-ink-light hover:text-ink hover:bg-white/10"
              }`}
            >
              Home
            </Link>
            {hasToken && (
              <Link
                to="/trips"
                className={`px-3.5 py-2 text-sm rounded-lg transition-colors font-medium ${
                  isActive("/trips")
                    ? "text-deep bg-warm"
                    : "text-ink-light hover:text-ink hover:bg-white/10"
                }`}
              >
                My Trips
              </Link>
            )}
            <Link
              to="/?section=explore"
              className="px-3.5 py-2 text-sm text-ink-light hover:text-ink rounded-lg transition-colors hover:bg-white/10 font-medium"
            >
              Explore
            </Link>
            <Link
              to="/?section=about"
              className="px-3.5 py-2 text-sm text-ink-light hover:text-ink rounded-lg transition-colors hover:bg-white/10 font-medium"
            >
              About
            </Link>
            {!hasToken && (
              <Link
                to="/planner-preview"
                className={`px-3.5 py-2 text-sm rounded-lg transition-colors font-medium ${
                  isActive("/planner-preview")
                    ? "text-deep bg-warm"
                    : "text-ink-light hover:text-ink hover:bg-white/10"
                }`}
              >
                Planner Preview
              </Link>
            )}

            <div className="w-px h-5 mx-2 bg-white/20" />

            {hasToken ? (
              <button
                onClick={() => {
                  logout();
                  window.location.href = "/";
                }}
                className="px-3.5 py-2 text-sm text-ink-light hover:text-ink rounded-lg transition-colors"
              >
                Sign out
              </button>
            ) : (
              <Link
                to="/auth/login"
                className="text-sm px-5 py-2 bg-accent text-deep rounded-lg hover:bg-accent-light transition-colors font-semibold"
              >
                Get started
              </Link>
            )}
          </nav>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="sm:hidden p-2 text-ink"
            aria-label="Toggle menu"
          >
            {mobileOpen ? (
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>

        {mobileOpen && (
          <div className="sm:hidden border-t border-white/15 px-1 py-4 space-y-1">
            <Link
              to="/"
              onClick={() => setMobileOpen(false)}
              className="block px-3 py-2.5 text-sm font-medium text-ink rounded-lg hover:bg-white/10"
            >
              Home
            </Link>
            {hasToken && (
              <Link
                to="/trips"
                onClick={() => setMobileOpen(false)}
                className="block px-3 py-2.5 text-sm font-medium text-ink rounded-lg hover:bg-white/10"
              >
                My Trips
              </Link>
            )}
            <Link
              to="/?section=explore"
              onClick={() => setMobileOpen(false)}
              className="block px-3 py-2.5 text-sm font-medium text-ink rounded-lg hover:bg-white/10"
            >
              Explore
            </Link>
            <Link
              to="/?section=about"
              onClick={() => setMobileOpen(false)}
              className="block px-3 py-2.5 text-sm font-medium text-ink rounded-lg hover:bg-white/10"
            >
              About
            </Link>
            {!hasToken && (
              <Link
                to="/planner-preview"
                onClick={() => setMobileOpen(false)}
                className="block px-3 py-2.5 text-sm font-medium text-ink rounded-lg hover:bg-white/10"
              >
                Planner Preview
              </Link>
            )}
            <div className="pt-2 mt-2 border-t border-white/15">
              {hasToken ? (
                <button
                  onClick={() => {
                    logout();
                    window.location.href = "/";
                  }}
                  className="px-3 py-2.5 text-sm text-ink-light"
                >
                  Sign out
                </button>
              ) : (
                <Link
                  to="/auth/login"
                  onClick={() => setMobileOpen(false)}
                  className="inline-block text-sm px-5 py-2.5 bg-accent text-deep rounded-lg font-semibold"
                >
                  Get started
                </Link>
              )}
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
